import { FileItem, FileStatus } from '@sib/types';
import { v4 as uuidv4 } from 'uuid';
import type { FileUploadStore } from './file-upload-store';

export const FILE_UPLOAD_DIALOG_FIELD_NAME = 'files' as const;

export const filesToFileItems = (files: File[]): FileItem[] =>
  files.map(file => ({
    id: uuidv4(),
    file,
    selected: false,
    status: FileStatus.Pending,
    progress: 0,
  }));

export const createFileUploadProgressCallbacks = (
  updateFile: FileUploadStore['updateFile']
) => ({
  onProgress: (fileItem: FileItem, progress: number) =>
    updateFile({
      ...fileItem,
      status: FileStatus.Uploading,
      progress,
    }),
  onSuccess: (fileItem: FileItem) =>
    updateFile({
      ...fileItem,
      status: FileStatus.Uploaded,
      progress: 100,
    }),
  onError: (fileItem: FileItem, error?: string) =>
    updateFile({
      ...fileItem,
      status: FileStatus.Error,
      errorMessage: error,
    }),
});
